import { ConfigProvider, Layout } from "antd";
import Footer from "common/footer";
import bem from "easy-bem";
import CaseContent from "features/cases/blocks/CaseContent";
import { useIsMobile } from "hooks/useIsMobile";
import { useScrollTo } from "hooks/useScrollTo";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import type { CaseShellProps } from "./CaseShell.types";
import AttrHeader from "./elements/AttrHeader";
import "./CaseShell.css";

const { Content } = Layout;

const cn = bem("case-shell");

const HEADER_COLOR: Record<string, string> = {
  problem: "#FFF2CB",
  solution: "#B7EAFF",
};

const CaseShell: React.FC<CaseShellProps> = ({
  kind,
  problemId,
  solutionId,
  isAdding,
  initialScroll = "top",
  setSolsExpanded,
  setProbExpanded,
  probExpanded,
  setCaseExpanded,
  caseExpanded = false,
  footer,
  onboardingNodes,
}) => {
  const { isMobile } = useIsMobile();
  const location = useLocation();

  const { scrollTo } = useScrollTo();

  const setTab = (tab: string, solsExpand = false) => {
    scrollTo(tab);
    setSolsExpanded?.(solsExpand);
    setProbExpanded?.(!solsExpand);
  };

  useEffect(() => {
    // Хэш конкретной карточки важнее дефолтного скролла — иначе они
    // конкурируют, и дефолтный обычно побеждает первым.
    if (location.hash) return;

    if (initialScroll === "top") {
      setTab("topcard");
    } else {
      setTab("secondcard", kind === "problem");
    }
  }, []);

  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerBg: HEADER_COLOR[kind],
            headerHeight: "auto",
            headerPadding: "12px 12px",
          },
        },
      }}
    >
      {onboardingNodes}

      <Layout className={cn()}>
        <AttrHeader
          kind={kind}
          setSolsExpanded={setSolsExpanded}
          probExpanded={probExpanded}
          setProbExpanded={setProbExpanded}
          setCaseExpanded={setCaseExpanded}
          caseExpanded={caseExpanded}
        />

        <Content className={cn("content", { mobile: isMobile })}>
          <CaseContent
            problemId={problemId}
            solutionId={solutionId}
            kind={kind}
            probExpanded={kind === "problem" ? true : probExpanded}
            setProbExpanded={setProbExpanded}
            setCaseExpanded={setCaseExpanded}
            caseExpanded={caseExpanded}
            isAdding={isAdding}
          />
        </Content>

        <Footer>{footer}</Footer>
      </Layout>
    </ConfigProvider>
  );
};

export default CaseShell;
